// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__3eskK","calendarButtons":"ClockData_calendarButtons__37UpK"};